module.exports = __webpack_public_path__ + "img/3d-desktop_en.6dd5725.jpg";